import { appStore } from "src/appStore";
import { getLangName } from "src/types/ZLanguageProps";
import { MakeLabelParams } from "../types/MakeLabelParams";
import { getAttrLabelTreeData } from "../utils/getAttrLabelTreeData";

export const makeContentLangLabel = (params: MakeLabelParams) => {
  const values = getAttrLabelTreeData(
    params.attribute,
    params.labelTreeData,
  )?.labels;
  const code = values?.[0] ?? "";
  const lang = appStore.contentLangMap[code];
  return lang ? getLangName(lang) : code;
};
